import React, {
  lazy,
}                from 'react';
import ReactDOM  from 'react-dom/client';
import Router, {
  Switch,
  Route,
}                from 'crossroad';

import './index.css';

const App = lazy(() => import('./App'));
const Landing = lazy(() => import('./screens/Landing'));
const ErrorPage = lazy(() => import('./screens/ErrorPage'));


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path='/landing/preview' component={Landing} />
        <Route path='/landing/:public_instance_id' component={Landing} />
        <Route path='/landing/public/:public_template_id' component={Landing} />
        <Route path='/' component={App} />
        <Route><ErrorPage/></Route>
      </Switch>
    </Router>
  </React.StrictMode>
</>);
